import React from 'react';
import MuiDialog from '@material-ui/core/Dialog';
import makeStyles from '@material-ui/core/styles/makeStyles';
import { DialogActions, DialogContent, DialogTitle } from '@material-ui/core';
import Button from '@material-ui/core/Button';


const useStyles = makeStyles(theme => ({
  root: {
    overflow: 'visible',
    width: '100%',
    maxWidth: 460,
    backgroundColor: theme.palette.background.paper,
  },
  paper: {
    width: '80%',
    maxHeight: 435,
  },
}));

const Dialog = ({ opened, onClose, onSubmit }) => {
  const classes = useStyles();

  const handleSubmit = () => {
    onSubmit();
    onClose();
  }

  return (
    <MuiDialog open={opened} classes={{ paperScrollPaper: classes.root }}  maxWidth="sm"  onClose={onClose}>
      <DialogTitle id="confirmation-dialog-title">Storno účtenky</DialogTitle>
      <DialogContent dividers>
        Skutečně si přejete stornovat účtenku?
      </DialogContent>
      <DialogActions>
        <Button autoFocus onClick={onClose} color="primary">
          Zrušit
        </Button>
        <Button onClick={handleSubmit} color="primary">
          Ok
        </Button>
      </DialogActions>
    </MuiDialog>
  );
};

export default Dialog;
